var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "gear",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.328,
    height: 15.328,
    viewBox: "0 0 15.328 15.328",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2391",
    "data-name": "Trac\\xE9 2391",
    d: "M14.948,6.238,13.58,6.074A6.108,6.108,0,0,0,12.971,4.6l.85-1.081a.444.444,0,0,0-.035-.573l-1.41-1.41A.445.445,0,0,0,11.8,1.5l-1.083.852a6.024,6.024,0,0,0-1.469-.607L9.089.38A.444.444,0,0,0,8.66,0H6.666a.443.443,0,0,0-.429.38L6.073,1.748a6.072,6.072,0,0,0-1.47.608l-1.082-.85a.444.444,0,0,0-.572.034L1.539,2.95a.445.445,0,0,0-.033.573L2.356,4.6a6.057,6.057,0,0,0-.608,1.471L.381,6.24A.444.444,0,0,0,0,6.669V8.663a.444.444,0,0,0,.381.429l1.368.164a6.094,6.094,0,0,0,.608,1.469l-.85,1.083a.445.445,0,0,0,.035.573l1.408,1.411a.445.445,0,0,0,.572.035L4.6,12.973a6.034,6.034,0,0,0,1.47.608l.164,1.367a.443.443,0,0,0,.429.38H8.661a.442.442,0,0,0,.429-.38l.164-1.367a6.087,6.087,0,0,0,1.47-.608l1.083.85a.444.444,0,0,0,.572-.034l1.41-1.411a.444.444,0,0,0,.034-.573l-.851-1.082a6.065,6.065,0,0,0,.608-1.47l1.367-.164a.443.443,0,0,0,.381-.429V6.668A.442.442,0,0,0,14.948,6.238ZM7.664,11.5A3.832,3.832,0,1,1,11.5,7.664,3.832,3.832,0,0,1,7.664,11.5Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsWhiteIcon);
export default __webpack_public_path__ + "static/media/settingsWhiteIcon.66c9f143afda083041c09c50c64b6605.svg";
export { ForwardRef as ReactComponent };